import { getType } from './helpers/typeModifier';
import { changeErrorStatus, changeFetchingStatusNew } from './newCollection';

const popularImgReducer = (state, action, type) => {
    let newState;

    const reducerType = getType(type, action.url);

    switch (action.type) {
        case `ERROR_${type.toUpperCase()}`:
            newState = {
                ...state,
                ...changeFetchingStatusNew(state, reducerType, false),
                ...changeErrorStatus(state, reducerType, true)
            };
            break;

        case `RECEIVE_${type.toUpperCase()}`: {
            newState = {
                ...state,
                ...changeFetchingStatusNew(state, reducerType, false)
            };
            break;
        }
        case `REQUEST_${type.toUpperCase()}`: {
            newState = {
                ...state,
                ...changeFetchingStatusNew(state, reducerType, true),
                ...changeErrorStatus(state, reducerType, false)
            };
            break;
        }

        default: {
            newState = state;
        }
    }

    return newState;
};

export {
    popularImgReducer
};
